import { baseApi } from '@shared/api'

interface SetByMeRespone {
  id: number
  fullName: string
  pin: string
  phone: string
  expiryDate: string
}
export interface ServiceOption {
  readonly active: boolean
  readonly commission: number
}

export interface PreparationTimeConfig {
  readonly urgent: ServiceOption
  readonly ordinary: ServiceOption
}

export interface OrderDeliveryConfig {
  readonly courier: ServiceOption
  readonly bank: ServiceOption // "bank" filialda təhvil verilməni təmsil edir.
}

export interface CardProductConfig {
  readonly preparationTime: PreparationTimeConfig
  readonly orderDelivery: OrderDeliveryConfig
}

export interface CoreConfigResponse {
  readonly branchNo: string
  readonly salaryCard: CardProductConfig
  readonly businessCard: CardProductConfig
}

export const branchListApi = baseApi.injectEndpoints({
  endpoints(builder) {
    return {
      fetchBranchList: builder.query<any, void>({
        query: () => ({
          url: '/ib/core/bank/branches',
          method: 'POST',
        }),
        serializeQueryArgs: () => 'fetchBranchList',
      }),
      trustedPersonByPin: builder.query<any, { pin: string }>({
        query: ({ pin }) => ({
          url: '/ib/core/trusted-person/by-pin',
          data: { pin },
          method: 'POST',
          skipGlobalError: true,
        }),
      }),
      trustedPersonListAll: builder.query({
        query: () => ({
          url: '/ib/core/trusted-person/get-all',
          method: 'POST',
          skipGlobalError: true,
        }),
        providesTags: (result, err) => {
          return [{ type: 'TrustedPersonList' }]
        },
      }),
      deleteTrustedPerson: builder.mutation({
        query: (data) => ({
          url: '/ib/core/trusted-person/delete',
          method: 'POST',
          data,
        }),
        invalidatesTags: ['TrustedPersonList'],
      }),
      setTrustedPersonByMe: builder.query<SetByMeRespone, void>({
        query: () => ({
          url: '/ib/core/trusted-person/customers-by-pin',
          method: 'POST',
          skipGlobalError: true,
        }),
      }),
      coreConfig: builder.query<CoreConfigResponse, void>({
        query: () => ({
          url: '/ib/core/configs',
          method: 'POST',
        }),
      }),
    }
  },
})

export const {
  useFetchBranchListQuery,
  useLazyFetchBranchListQuery,
  useDeleteTrustedPersonMutation,
  useLazySetTrustedPersonByMeQuery,
  useLazyTrustedPersonByPinQuery,
  useLazyTrustedPersonListAllQuery,
  useSetTrustedPersonByMeQuery,
  useTrustedPersonByPinQuery,
  useTrustedPersonListAllQuery,
  useCoreConfigQuery,
  useLazyCoreConfigQuery,
} = branchListApi
